import request from '@/utils/request'

export function fetchList(query) {
  return request({
    url: '/vue-element-admin/article/list',
    method: 'get',
    params: query
  })
}
//用户移除角色
export function removeRoles(data){
  return request({
    url:'/sys/roleUser/delRole',
    method:'post',
    data
  })
}
//选择角色
export function chooseRole(params){
  return request({
    url:'/chooseRole',
    method:'post',
    params
  })
}
//下载文件
export function getFile(params) {
  return request({
    url: '/common/download-file',
    method: 'get',
    params
  })
}

//根据id查询文件
export function searchFileList(params) {
  return request({
    url: '/common/file-lists',
    method: 'get',
    params
  })
}

//查询登录页背景图
export function loginBackgroundImg(params) {
  return request({
    url: '/base/slider/image',
    // url: '/common/queryLoginImgs',
    method: 'get',
    params
  })
}

//查询部门列表
export function allDeptList(params) {
  return request({
    url: '/common/dept-lists',
    method: 'get',
    params
  })
}

//查询全部账号类型
export function allUserTypeList(params) {
  return request({
    url: '/common/persn-user-type-lists',
    method: 'get',
    params
  })
}

//查询全部用户
export function allUserList(params) {
  return request({
    url: '/common/persn-user-lists',
    method: 'get',
    params
  })
}

// 菜单树桩列表
export function cdListTree(query) {
  return request({
    url: '/sys/menu/listTree',
    method: 'get',
    params: query
  })
}

// 查询角色菜单
export function menuTree(query) {
  return request({
    url: '/sys/rolemenu/menuTree',
    method: 'get',
    params: query
  })
}

// 编辑菜单/保存菜单
export function addOrUpdCd(data) {
  return request({
    url: '/sys/menu/edit',
    method: 'post',
    data
  })
}

// 删除菜单
export function delCd(data) {
  return request({
    url: '/sys/menu/dels',
    method: 'post',
    data
  })
}

// 部门树桩列表
export function bmListTree(query) {
  return request({
    url: '/sys/dept/listTree',
    method: 'get',
    params: query
  })
}

//删除部门
export function delBm(data) {
  return request({
    url: '/sys/dept/dels',
    method: 'post',
    data
  })
}

//角色列表无分页
export function jsList(query) {
  return request({
    url: '/sys/role/lists',
    method: 'get',
    params: query
  })
}

//添加用户/编辑用户
export function addOrUpdUser(data) {
  return request({
    url: '/sys/user/edit',
    method: 'post',
    data
  })
}

//查询用户
export function finduserinfo(query) {
  return request({
    url: '/sys/user/info',
    method: 'get',
    params: query
  })
}

//修改系统用户状态
export function updsysYhzt(data) {
  return request({
    url: '/sys/user/changeStatus',
    method: 'post',
    data
  })
}

//用户管理-重置密码
export function restartPwdUser(data) {
  return request({
    url: '/sys/user/reset',
    method: 'post',
    data
  })
}

//用户管理-删除用户
export function delUser(data) {
  return request({
    url: '/sys/user/dels',
    method: 'post',
    data
  })
}

//用户管理-导出
export function downloadUser(params) {
  return request({
    url: '/sys-user/export',
    method: 'get',
    responseType: 'arraybuffer',
    params
  })
}

//查询码表列表
export function mbglListPage(query) {
  return request({
    url: '/sys/dmgl/listPage',
    method: 'get',
    params: query
  })
}

//查询码表数据
export function dataList(query) {
  return request({
    url: '/sys/dmgl/dataList',
    method: 'get',
    params: query
  })
}

//
export function deptList(params) {
  return request({
    url: '/sys/dept/lists',
    method: 'get',
    params
  })
}

//查询码表结构
export function colList(query) {
  return request({
    url: '/sys/dmgl/colList',
    method: 'get',
    params: query
  })
}

//查询待新增的码表
export function tabList(query) {
  return request({
    url: '/sys/dmgl/tabList',
    method: 'get',
    params: query
  })
}

//查询登录日志列表
export function fwjlListPage(query) {
  return request({
    url: '/sys/loginlog/listPage',
    method: 'get',
    params: query
  })
}

//删除登录日志
export function delFwjl(data) {
  return request({
    url: '/sys/loginlog/dels',
    method: 'post',
    data: data
  })
}

//文件列表
export function wjListPage(query) {
  return request({
    url: '/sys/file/listPage',
    method: 'get',
    params: query
  })
}

//更改文件下载状态
export function changeFile(data) {
  return request({
    url: '/sys/file/edit',
    method: 'post',
    data
  })
}

//删除文件
export function deleteFile(data) {
  return request({
    url: '/sys/file/dels',
    method: 'post',
    data
  })
}


//登录日志导出
export function exportRzList(query) {
  return request({
    url: '/sys/loginlog/export',
    method: 'get',
    params: query
  })
}

//菜单导出
export function exportCdList(query) {
  return request({
    url: '/sys/menu/export',
    method: 'get',
    params: query
  })
}


// 系统用户列表
export function xtUserList(query) {
  return request({
    url: '/sys/user/listPage',
    method: 'get',
    params: query
  })
}
